var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.1,507.8C119.1,507.8,8,395.4,8.5,255.4C9.1,117.4,120.4,4.8,259.7,6.2   c136.4,1.4,247,113.5,245.8,253.1C504.3,396.6,394.3,507.5,257.1,507.8z M257.3,25.8C133.1,25.3,29.5,126.4,28.1,254.2   C26.6,384.6,130.7,487,254.7,488.2c125.7,1.2,230.4-100.5,231.2-228.9C486.6,129.6,384.4,25.8,257.3,25.8z",
    fill: "#02ACED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.9,267.1c25.7,0,51.3,0.1,77-0.1c4.1,0,5,1.3,5,5.1c-0.1,44.2-0.1,88.3,0,132.5c0,3.9-1.1,4.8-4.9,4.3   c-50.5-7.1-100.9-14.1-151.4-21.1c-7.7-1.1-7.7-1-7.7-8.7c0-35.8,0.1-71.7-0.1-107.5c0-4.5,1.3-5.6,5.7-5.6   c25.5,0.2,51,0.1,76.5,0.1C325.9,266.4,325.9,266.7,325.9,267.1z",
    fill: "#02ACED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.4,251.2c-25.5,0-51-0.1-76.5,0.1c-3.8,0-5.2-0.9-5.2-5c0.2-36.8,0.2-73.6,0-110.5   c0-3.8,1.3-5.2,4.9-5.7c51.4-7.1,102.9-14.2,154.3-21.5c4-0.6,4.9,0.4,4.8,4.2c-0.1,44.2-0.1,88.3,0,132.5c0,4.5-1.8,5.2-5.5,5.2   c-25.6-0.1-51.3,0-77,0C325.4,250.7,325.4,250.9,325.4,251.2z",
    fill: "#02ACED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,265.9c19,0,38,0.1,57-0.1c4.2,0,4.9,1.5,4.9,5.2c-0.1,36.2-0.2,72.3,0,108.5c0,4.4-1.7,5-5.3,4.4   c-17.3-2.5-34.6-5-51.9-7.4c-20.8-2.9-41.5-5.8-62.4-8.5c-3.3-0.4-4-1.8-4-4.8c0.1-31.3,0.1-62.7,0-94c0-3.2,0.9-4.2,4.2-4.2   c19.2,0.2,38.3,0.1,57.5,0.1C168,265.4,168,265.6,168,265.9z",
    fill: "#02ACED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,252.6c-19.8,0-39.6-0.1-59.4,0.1c-3.2,0-4.4-0.9-4.4-4.2c0.1-31.5,0.1-62.9,0-94.4   c0-3.4,1.5-4.1,4.3-4.5c24.7-3.4,49.4-6.9,74.2-10.3c13.5-1.9,27-3.6,40.5-5.7c3.7-0.6,4.6,0.5,4.6,4.1c-0.1,36.5-0.1,72.9,0,109.4   c0,3.9-1.3,4.8-4.9,4.8c-18.3-0.1-36.6-0.1-54.9-0.1C170,251.9,170,252.3,170,252.6z",
    fill: "#02ACED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.98877d41bb8316508ca7e9e84a61030c.svg";
export { ForwardRef as ReactComponent };